import { render, staticRenderFns } from "./category-explorer.vue?vue&type=template&id=82a71dc2&"
import script from "./category-explorer.vue?vue&type=script&lang=js&"
export * from "./category-explorer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports